import { render, staticRenderFns } from "./review-data.vue?vue&type=template&id=cc96963a&"
import script from "./review-data.vue?vue&type=script&lang=js&"
export * from "./review-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc96963a')) {
      api.createRecord('cc96963a', component.options)
    } else {
      api.reload('cc96963a', component.options)
    }
    module.hot.accept("./review-data.vue?vue&type=template&id=cc96963a&", function () {
      api.rerender('cc96963a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/pages/dataImport/components/review-data.vue"
export default component.exports